import { render, staticRenderFns } from "./ZendeskLauncher.vue?vue&type=template&id=0a9c63a4&"
import script from "./ZendeskLauncher.vue?vue&type=script&lang=js&"
export * from "./ZendeskLauncher.vue?vue&type=script&lang=js&"
import style0 from "./ZendeskLauncher.vue?vue&type=style&index=0&id=0a9c63a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports